import { actions } from "./actions";
import axios from "axios";
import { urls } from "../../../dispatch/urls";
// Same scanner API as scanner.jumiadash.store, served by the dashboard backend behind the dashboard login
const baseUrlStoreApi = `${urls.baseUrlRestApi}/scanner`
export const dispatch = async (action: string, body?: Object, headerParams?: any) => {
    try{
        let response = {} as any
    let axiosOptions = {} as any
    switch(action){
        case actions.getStores:
            axiosOptions = getAxiosOptions("GET", `${baseUrlStoreApi}/store`)
            response = await axios(axiosOptions)
            return response.data
        case actions.getAllOrders:
            axiosOptions = getAxiosOptions("GET", `${baseUrlStoreApi}/orders/${headerParams.storeId}`)
            response = await axios(axiosOptions)
            return response.data
        case actions.findOrder:
            axiosOptions = getAxiosOptions("GET", `${baseUrlStoreApi}/order/${encodeURIComponent(headerParams.code)}`)
            response = await axios(axiosOptions)
            return response.data
        case actions.getRtsPacking:
            axiosOptions = getAxiosOptions("GET", `${baseUrlStoreApi}/rts`)
            response = await axios(axiosOptions)
            return response.data
        case actions.findProduct:
            axiosOptions = getAxiosOptions("GET", `${baseUrlStoreApi}/find?q=${encodeURIComponent(headerParams.q)}`)
            response = await axios(axiosOptions)
            return response.data
        case actions.sendLabels:
            axiosOptions = getAxiosOptions("POST", `${baseUrlStoreApi}/send-labels`, {})
            response = await axios(axiosOptions)
            return response.data
        case actions.sendLabelsStatus:
            axiosOptions = getAxiosOptions("GET", `${baseUrlStoreApi}/send-labels/status`)
            response = await axios(axiosOptions)
            return response.data
        case actions.holdOrder:
            axiosOptions = getAxiosOptions("POST", `${baseUrlStoreApi}/hold`, body)
            response = await axios(axiosOptions)
            return response.data
        case actions.releaseOrder:
            axiosOptions = getAxiosOptions("POST", `${baseUrlStoreApi}/release`, body)
            response = await axios(axiosOptions)
            return response.data
        case actions.refreshNow:
            axiosOptions = getAxiosOptions("POST", `${baseUrlStoreApi}/refresh-now`, {})
            axiosOptions.timeout = 120000
            response = await axios(axiosOptions)
            return response.data
        case actions.getCancelAlerts:
            axiosOptions = getAxiosOptions("GET", `${baseUrlStoreApi}/cancelled-alerts`)
            response = await axios(axiosOptions)
            return response.data
        case actions.ackCancelAlert:
            axiosOptions = getAxiosOptions("POST", `${baseUrlStoreApi}/cancelled-alerts/ack`, body)
            response = await axios(axiosOptions)
            return response.data
        case actions.getMarjanPacking:
            axiosOptions = getAxiosOptions("GET", `${baseUrlStoreApi}/marjan`)
            response = await axios(axiosOptions)
            return response.data
        case actions.findReturn:
            axiosOptions = getAxiosOptions("GET", `${baseUrlStoreApi}/return/${encodeURIComponent(headerParams.code)}${headerParams.round ? `?round=${encodeURIComponent(headerParams.round)}` : ""}`)
            response = await axios(axiosOptions)
            return response.data
        case actions.receiveReturn:
            axiosOptions = getAxiosOptions("POST", `${baseUrlStoreApi}/return`, body)
            response = await axios(axiosOptions)
            return response.data
        case actions.collectReturn:
            axiosOptions = getAxiosOptions("POST", `${baseUrlStoreApi}/return/collect`, body)
            response = await axios(axiosOptions)
            return response.data
        case actions.searchGroups:
            axiosOptions = getAxiosOptions("GET", `${baseUrlStoreApi}/groups?q=${encodeURIComponent(headerParams?.q || "")}`)
            response = await axios(axiosOptions)
            return response.data
        case actions.substitute:
            axiosOptions = getAxiosOptions("POST", `${baseUrlStoreApi}/substitute`, body)
            response = await axios(axiosOptions)
            return response.data
        case actions.substituteRemove:
            axiosOptions = getAxiosOptions("POST", `${baseUrlStoreApi}/substitute/remove`, body)
            response = await axios(axiosOptions)
            return response.data
        case actions.setDone:
            axiosOptions = getAxiosOptions("POST", `${baseUrlStoreApi}/done`, body)
            response = await axios(axiosOptions)
            return response.data
        case actions.getHandoverAlerts:
            axiosOptions = getAxiosOptions("GET", `${baseUrlStoreApi}/alerts?days=${headerParams?.days || 30}`)
            response = await axios(axiosOptions)
            return response.data
        case actions.marjanPrep:
            axiosOptions = getAxiosOptions("POST", `${baseUrlStoreApi}/marjan/prep`, body)
            response = await axios(axiosOptions)
            return response.data
    }

    }
    catch(err: any){
        console.log(err)
        return err?.response?.data || { error: { message: "Network error — please try again" } }
    }
}
const getAxiosOptions = (method: string, url: string, body?: Object) => {
    const headers = {
        "Content-Type": "application/json",
        "x-auth-token": localStorage.getItem("token") || "",
    };
    switch (method) {
        case "GET":
            return {
                method: "GET",
                url,
                headers,
            };
            break;
        case "POST":
            return {
                method: "POST",
                url,
                headers,
                data: body,
            };
            break;
        case "PUT":
            return {
                method: "PUT",
                url,
                headers,
                data: body,
            };
            break;
        case "DELETE":
            return {
                method: "DELETE",
                url,
                headers,
            };
            break;
    }
};